import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Icon, Collapse } from 'antd';
import { Checkbox, Tooltip } from 'antd';
import { agreeToTerms as agreeToTermsApi } from '../../api-calls/user';

Modal.setAppElement('#root')

@observer(["ViewStore", "CustomWagerStore", "UserStore", "web3Store", "AuthStore"])
class WelcomeCardModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            checkboxChecked: false,
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }


    componentWillMount() {
        setTimeout(
            function () {
                if (!this.props.UserStore.user.termsAgreedTo) {
                    this.setState({ modalIsOpen: true })
                } else {
                    this.setState({ modalIsOpen: false })
                }
            }.bind(this), 1900);
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    render() {
        let closeBtn = <button onClick={this.closeModal} className="custom-btn-danger">Close</button>
        const Panel = Collapse.Panel;

        const customPanelStyle = {
            background: '#11324a',
            borderRadius: 4,
            marginBottom: 10,
            borderBottom: "1px solid rgba(255,255,255,0)",
            overflow: 'hidden',
        };

        return (
            <div className="help-modal-open-btn" >
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Help Modal"
                    className="help-modal"
                    overlayClassName="help-modal-overlay">
                    <div className="help-modal-content-wrap">
                        <div className="help-modal-content-header">Welcome to the meVu testnet beta!
                        <div className="help-modal-content-header-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div></div>
                        <div className="help-modal-content">
                            <p>
                                Welcome and thank you for trying out our dApp in its testnet phase. We will be using this as an opportunity to find bugs and improve the platform wherever
                            possible based on users feedback prior to our launch on the main Ethereum network. Please feel free reach out to us via our social channels with any ideas
                            for improvement or potential issues you may have found. We will be updating the platform regularly so please have patience if there is a stretch where no games
                            are available, it likely means we are in the midst of fixing an error and they will be back soon.
                                <br />
                                <br />
                                Below are the answers to some basic questions which should be known before using this dApp. Other helpful information will be available thorugh clicking the question mark icon
                                in the top right corner of the interface.
                        </p>
                            <Collapse bordered={false} defaultActiveKey={[]}>
                                <Panel header={<div><Icon style={{fontSize: '24px', marginRight: '10px' }} type="wallet" />  What is MetaMask?</div>} key="1" style={customPanelStyle}>
                                    <p>Metamask is a browser extension that allows users to interact with the Ethereum blockchain. It is currently the suggested method of using the meVu dApp.</p>
                                </Panel>
                                <Panel header={<div><Icon style={{ fontSize: '24px',marginRight: '10px' }} type="experiment" />  What is Rinkbey?</div>} key="2" style={customPanelStyle}>
                                    <p>Rinkeby is the name of a test Ethereum network and the only test network in use for this dApp. Test ETH for Rinkeby is available <a href="https://faucet.rinkeby.io/">here.</a> Always be aware of which network your Metamask extension is set to interact with.</p>
                                </Panel>
                                <Panel header={<div><Icon style={{ fontSize: '24px',marginRight: '10px' }} type="file-unknown" />  How to make a bet?</div>} key="3" style={customPanelStyle}>
                                    <p>There are two types of bets, one on large public events like sports matches with people you do not know, and the other on whatever you wish taken as a challenge by a friend or rival you already have a relationship with.</p>

                                    <p>For sports bets, navigate to the teams page or the featured events page with your chosen match.
                                         To create a new bet click the button directly beneath the team name of your choice and adjust the bet
                                          specifics to your liking in the bet slip. However be aware that if your chosen bet sizing and odds
                                           is not favourable for anyone to take no other player will accept your bet and you will simply be refunded
                                            after the match. The other side of creating a bet is taking a bet created by someone else. Available bets are
                                             listed beneath the team you are betting on winning if you take one. Once the Metamask transaction sending the funds has
                                             been confirmed the bet will either appear or become unavailable depending on if creating or taking a bet. You can view your bets status
                                             in the 'My Bets' section of the application. </p>
                                </Panel>
                                <Panel header={<div><Icon style={{fontSize: '24px', marginRight: '10px' }} type="bank" />  How to settle a bet?</div>} key="4" style={customPanelStyle}>                                    

                                    <p>For sports bets, wait until the match has concluded and then navigate to the bet in the 'My Bets' section. You should see a button prompting you to input the winner of the
                                        event. If you an your opponent both do this before the 'Oracle Period' (seen in the settings drawer) expires the fee for the bet will only be two percent. Otherwise, or if
                                        you and your opponent disagree, the Oracle input will be used to determine the winner and the fee will be 3 percent. If the Oracle input is required the winner must wait until
                                        Oracle Period expires before triggering payout. If the players agree  (prior to the OP expiring), payout will be triggered by the input of the second bettor.                                
                                        
                                    </p>
                                    <p>
                                        Be aware, losing a dispute or not reporting an outcome before the Oracle period ends results in a loss of reputation which may decrease the likelihood
                                         of your future bets being matched.</p>

                                    <p>Custom bets are a little different in that they have no Oracles to rely on so the betttors have the option of appointing a Judge, prior to the bet transpiring, 
                                        who has final say in the event of a dispute. More information will be made available through tooltips like <Tooltip title={<span>This is a helpful tooltip.</span>} >
                         {/* <a href="https://mevu.bet/fees">Full Fee Breakdown</a></span>}> */}
                                <a>this</a>
                            </Tooltip> in the 'Custom Bets' section.</p>    
                                </Panel>
                            </Collapse>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default observer(WelcomeCardModal);


// WEBPACK FOOTER //
// ./src/components/modals/WelcomeCardModal.js